import React from 'react';
import { connect } from '@gasbuddy/react';
import MainLayout from '../../components/main-layout';
import UserList from '../../components/user-list';

/* eslint-disable react/prefer-stateless-function */
function UserManagement() {
  return (
    <MainLayout title="User Management">
      <UserList />
    </MainLayout>
  );
}

export default connect()(UserManagement);
